module.exports = __webpack_public_path__ + "static/assets/d151ca24b60baa5b206ef4bb01cb99db.svg";